var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForeignPlayer = function SvgForeignPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB923C",
    d: "m11.507.619-2.1-.454A1.26 1.26 0 0 0 8.383.39L2.04 4.999.517 4.932a.417.417 0 0 0-.277.74L1.723 6.85a.18.18 0 0 0 .177.03c.423-.164 2-1 3.863-2.024l.374 3.837a.183.183 0 0 0 .3.123l.833-.693a.25.25 0 0 0 .087-.15l.79-4.43A538 538 0 0 0 11.65 1.58a.516.516 0 0 0-.143-.96"
  })));
};
export default SvgForeignPlayer;